<div class="mb-4 d-flex justify-content-start align-items-center" *ngIf="selectedIndex != 2">
  <button mat-icon-button aria-label="Previous Slide" class="back-btn position-relative" *ngIf="!is_websignup && selectedIndex == 1 && !is_fromSignup && !is_session_created" (click)="backToSignupPage()">
    <mat-icon>keyboard_arrow_left</mat-icon>
  </button>
  <div style="font-size:20px;" class="fw-bolder"> {{ selectedIndex == 0 ? params?.type == 'free_trial' ? 'Get Started with Your Free Trial' : 'Create Your Organization on Truein' :
    'Verify your ' + (verificationScreenIndex == 0 ? 'Email' : 'Mobile') }}</div>
  <!-- <small class="text-secondary">
      Signup to create an account with us
  </small> -->
</div>

<mat-tab-group class="signup-section-wrapper" [(selectedIndex)]="selectedIndex">
  <mat-tab disabled>
    <ng-template matTabContent>
      <form autocomplete="off" [formGroup]="signup_form" (submit)="is_updating_client ? updateClient() : freeTrialSignUp()">
        <div class="row">
          <div class="col-12 pb-0 pb-lg-3 d-flex flex-lg-row flex-column">
              <mat-form-field style="width: 68%;" class="pe-2">
                  <mat-label>Company Name</mat-label>
                  <input matInput autocomplete="off" formControlName="company_name" aria-label="Enter company name">
                  <mat-error *ngIf="signup_form.get('company_name')?.hasError('required')">
                      Company Name is <strong>required</strong>
                  </mat-error>
                  <mat-error *ngIf="signup_form.get('company_name')?.hasError('specialChars')">
                    <strong>Special characters</strong> not allowed
                  </mat-error>
                  <mat-error *ngIf="signup_form.get('company_name')?.hasError('urlsOrScripts') && !signup_form.get('company_name')?.hasError('specialChars')">
                    Enter a valid <strong>Company Name</strong>
                  </mat-error>
              </mat-form-field>

              <mat-form-field style="width: 32%; line-height: 1.3;" class="ps-2">
                  <mat-label>Headcount</mat-label>
                  <mat-select formControlName="company_size">
                      <mat-option *ngFor="let size of potential_total_users;" [value]="size.value">
                          {{size.displayValue}}
                      </mat-option>
                  </mat-select>
                  <mat-error *ngIf="signup_form.get('company_size')?.hasError('required')">
                    Headcount is <strong>required</strong>
                  </mat-error>
              </mat-form-field>
          </div>

          <div class="d-flex flex-lg-row flex-column col-12 pb-0 pb-lg-3 signup-row-name">
            <mat-form-field class="w-50">
                <mat-label>First Name</mat-label>
                <input matInput autocomplete="off" formControlName="first_name" aria-label="Enter your name">
                <mat-error *ngIf="signup_form.get('first_name')?.hasError('required')">
                    First Name is <strong>required</strong>
                </mat-error>
                <mat-error *ngIf="signup_form.get('first_name')?.hasError('specialChars')">
                    <strong>Special characters</strong> not allowed
                </mat-error>
                <mat-error *ngIf="signup_form.get('first_name')?.hasError('urlsOrScripts') && !signup_form.get('first_name')?.hasError('specialChars')">
                  Enter a valid <strong>First Name</strong>
                </mat-error>
            </mat-form-field>

            <mat-form-field class="w-50">
                <mat-label>Last Name</mat-label>
                <input matInput autocomplete="off" formControlName="last_name" aria-label="Enter your name">
                <mat-error *ngIf="signup_form.get('last_name')?.hasError('required')">
                    Last Name is <strong>required</strong>
                </mat-error>
                <mat-error *ngIf="signup_form.get('last_name')?.hasError('specialChars')">
                    <strong>Special characters</strong> not allowed
                </mat-error>
                <mat-error *ngIf="signup_form.get('last_name')?.hasError('urlsOrScripts') && !signup_form.get('last_name')?.hasError('specialChars')">
                    Enter a valid <strong>Last Name</strong>
                </mat-error>
            </mat-form-field>
          </div>

          <div class="col-12 pb-0 pb-lg-3">
              <mat-form-field style="width: 20% !important;" class="pe-2">
                  <mat-select formControlName="country_code" [compareWith]="countryCodeComparator">
                      <mat-select-trigger>
                          <span>
                              {{signup_form.value.country_code ? '+' +
                              signup_form.value.country_code?.country_code : ''}}
                          </span>
                      </mat-select-trigger>
                      <mat-option>
                          <ngx-mat-select-search [formControl]="country_search_ctrl" [placeholderLabel]="'Search'"
                              [noEntriesFoundLabel]="'no match found!'">
                          </ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let country of filtered_country_options | async;" [value]="country" [matTooltip]="country?.country_name + ' ('+ country?.native_name +') +' + country?.country_code" [matTooltipDisabled]="getCountryOptLength(country)">
                          <img [src]="getFlagUrl(country)" alt="" style="width: 30px;" class="me-1">
                          {{ country?.country_name + ' ('+ country?.native_name +') +' + country?.country_code }}
                      </mat-option>
                  </mat-select>
                  <mat-error>
                      Please select <strong>country</strong>
                  </mat-error>
              </mat-form-field>
              <mat-form-field style="width: 80% !important" class="ps-2">
                  <mat-label>Contact Number</mat-label>
                  <input matInput type="number" (blur)="checkEmailMobileExist('mobile')" autocomplete="off" formControlName="mobile_number" aria-label="Enter contact number"/>
                  <mat-error *ngIf="signup_form.get('mobile_number')?.hasError('required')">
                      Contact number is <strong>required</strong>
                  </mat-error>
                  <mat-error *ngIf="!signup_form.get('mobile_number')?.hasError('required') && signup_form.get('mobile_number')?.hasError('mobile_already_exist')">
                      User with this Contact number <strong>already exist</strong>
                  </mat-error>
                  <mat-error *ngIf="signup_form.get('mobile_number')?.hasError('pattern') && !signup_form.get('mobile_number')?.hasError('mobile_already_exist') && !signup_form.get('mobile_number')?.hasError('required')">
                      Enter a valid <strong>Contact number</strong>
                  </mat-error>
              </mat-form-field>
          </div>

          <div class="col-12 pb-0 pb-lg-3">
              <mat-form-field class="w-100">
                  <mat-label *ngIf="officeInput.focused || signup_form.get('office_email').value != ''">Work Email (e.g. your.name&#64;company-name.com)</mat-label>
                  <mat-label *ngIf="!(officeInput.focused || signup_form.get('office_email').value != '')">Work Email</mat-label>
                  <input matInput #officeInput="matInput" (blur)="checkEmailMobileExist('email')" autocomplete="off" formControlName="office_email" aria-label="Enter work email">
                  <mat-error *ngIf="signup_form.get('office_email')?.hasError('required')">
                      Work Email is <strong>required</strong>
                  </mat-error>
                  <mat-error
                      *ngIf="signup_form.get('office_email')?.hasError('email')" >
                      Please enter a <strong>valid work email</strong>
                  </mat-error>
                  <mat-error *ngIf="signup_form.get('office_email')?.hasError('personal_email')">
                    Please enter your <strong>work email address. This form does not accept addresses from {{personal_email_domain}}</strong>
                  </mat-error>
                  <mat-error *ngIf="!(signup_form.get('office_email')?.hasError('email')) &&
                  signup_form.get('office_email')?.hasError('email_already_exist')">
                      User with this Email id <strong>already exist</strong>
                  </mat-error>
              </mat-form-field>
          </div>

          <div class="col-12 pb-3" [style.margin-top]="signup_form.get('office_email')?.hasError('personal_email') ? '1rem' : '0'">
              <mat-form-field class="w-100">
                  <mat-label>Set Password</mat-label>
                  <input matInput #passwordRef [type]="is_pass_type_password ? 'password' : 'text'" autocomplete="new-password" formControlName="password" aria-label="Enter password">
                  <mat-icon matSuffix style="cursor: pointer" (click)="is_pass_type_password = !is_pass_type_password;">{{
                      is_pass_type_password ?
                      'visibility' :
                      'visibility_off'}}</mat-icon>
                    <mat-error *ngIf="signup_form.controls['password'].invalid && (signup_form.controls['password'].dirty || signup_form.controls['password'].touched)">
                      <div *ngIf="signup_form.controls['password'].errors?.required">Password is <strong>required</strong></div>
                      <div *ngIf="!signup_form.controls['password'].errors?.required">{{getFieldErrorMsg('password')}}</div>
                    </mat-error>
              </mat-form-field>
          </div>
          <!-- <div class="col-12">
                <mat-form-field class="w-100">
                    <input matInput [type]="is_confirm_pass_type_password ? 'password' : 'text'" [errorStateMatcher]="cnfrm_pass_error_matcher" formControlName="confirm_password">
                    <mat-icon matSuffix style="cursor: pointer"
                        (click)="is_confirm_pass_type_password = !is_confirm_pass_type_password;">{{
                        is_confirm_pass_type_password ? 'visibility' :
                        'visibility_off'}}</mat-icon>
                    <mat-error *ngIf="signup_form.get('confirm_password')?.hasError('required')">
                        Confirm Password is <strong>required</strong>
                    </mat-error>
                    <mat-error
                        *ngIf="signup_form?.hasError('misMatch') && !signup_form.get('confirm_password').hasError('required')">
                        Password does not <strong>matched</strong>
                    </mat-error>
                </mat-form-field>
            </div> -->

          <div class="col-12 my-3 d-flex justify-content-center">
              <button mat-raised-button type="submit" class="btn btn-primary w-100"
                  [disabled]="is_loading || is_validation_pending">{{is_updating_client ? 'Update' : 'Sign Up'}}
                  <mat-icon *ngIf="is_loading" class="ms-2">
                      <mat-spinner diameter="25"></mat-spinner>
                  </mat-icon>
              </button>
          </div>

          <div class="d-flex justify-content-center login-text mt-2" [style.visibility]="is_updating_client || (is_signup_loading && is_websignup) ? 'hidden' : 'visible'">
            <span class="text-secondary mr-10">Already user?</span>
            <a class="text-link" (click)="redirectToLogin()">Login</a>
          </div>

          <div class="text-center mt-3 weekly-count-text text-secondary">
            <img src="assets/svg/signup-rocket.svg" class="me-1"> <span class="fw-bold">{{getWeeklyTrialCount()}} Global</span> companies signed up for a Truein trial last week
          </div>
        </div>
      </form>
    </ng-template>
  </mat-tab>
  <mat-tab disabled>
    <ng-template matTabContent>
      <div class="h-100 mt-5" [ngClass]="current_url.includes('/signup') ? 'pt-4' : ''">
        <app-verify-account [login_response]="signup_response" [from_page]="'signup'" (selected_tab)="getScreenIndex($event)" (loginDashboard)="is_fromSignup ? loginToDashboardFromSignup($event) : loginToDashboard()"></app-verify-account>
      </div>
    </ng-template>
  </mat-tab>
  <mat-tab disabled>
    <app-referral class="h-100" [from_page]="'signup'" style="overflow: scroll;" (loginDashboard)="openDashboardWindow($event)"></app-referral>
    <!-- <div class="referral-component">
    </div> -->
  </mat-tab>
</mat-tab-group>

